<template>
  <transition name="fade-fastly">
    <div class="pop-up">
      <div class="pop-up-shade" @click="hidePopup" />
      <div class="pop-up-box">
        <span class="close" @click="hidePopup"></span>
        <div class="_title">
          {{title}}
        </div>
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      required: false,
      type: String
    }
  },
  methods: {
    hidePopup () {
      this.$store.state.popupRequestIsActive = false
      this.$store.state.popupCookieIsActive = false
      this.$store.state.popupTermsIsActive = false
    }
  },
}
</script>